import { MOBILE_APPS } from './MobileAppsList.constants';
import {
  IMobileAppsListPresenterParams,
  IMobileAppsListPresenter,
  TMobileAppItem,
} from './MobileAppsList.types';

export function useMobileAppsListPresenter(
  params: IMobileAppsListPresenterParams
): IMobileAppsListPresenter {
  const presenter: IMobileAppsListPresenter = {
    get appsItems(): TMobileAppItem[] {
      return params.apps
        .map((app) => ({
          ...(MOBILE_APPS[app.name] || {}),
          url: app.url,
        }))
        .filter((app) => app.url && app.name) as TMobileAppItem[];
    },

    onAppClick(url: string): void {
      window.open(url, '_blank', 'noopener, noreferrer');
    },
  };

  return presenter;
}
